var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Terms and Conditions")]),_c('p',[_vm._v(" Terms and Conditions")])])}
var staticRenderFns = []

export { render, staticRenderFns }